import { Globe } from "lucide-react";
import { api } from "../lib/api";
import { getLang, setLang } from "../lib/i18n";

export const LangSwitch = ({ dark = false, loggedIn = false }) => {
  const lang = getLang();
  const pick = async (l) => {
    if (l === lang) return;
    if (loggedIn) await api.put("/auth/lang", { lang: l }).catch(() => {});
    setLang(l);
  };
  return (
    <div data-no-i18n className={`flex items-center gap-1 rounded-full px-1.5 py-1 text-xs font-bold ${dark ? "bg-white/10 text-white" : "bg-slate-100 text-slate-600"}`} data-testid="lang-switch">
      <Globe className="mx-0.5 h-3.5 w-3.5 opacity-70" />
      {["fr", "en"].map((l) => (
        <button key={l} type="button" data-testid={`lang-${l}`} onClick={() => pick(l)}
          className={`rounded-full px-2 py-0.5 uppercase transition-colors ${lang === l ? "bg-[#0b2c6b] text-white" : "hover:text-[#0b2c6b]"}`}>{l}</button>
      ))}
    </div>
  );
};
